import { Box } from '@modusign/design-system';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import './HelpButtonTooltip.scss';

interface HelpButtonTooltipProps {
  className: string;
}

/**
 * EnhancedToolTip 컴포넌트를 적용하려고 했는데, DocumentHeader 컴포넌트에서 사용되는
 * 다른 버튼의 툴팁과 이질감이 있어서 우선 같은 스타일을 사용하게 구현합니다.
 * 추후 디자인 시스템 Tooltip 개선할 때 개선하는 방향으로 제이드와 논의하여
 * 해당 스타일을 그대로 가져와서 적용합니다.
 */
function HelpButtonTooltip({ className }: HelpButtonTooltipProps) {
  const { t } = useTranslation();
  return <Box className={cx('HelpButtonTooltip', className)}>{t('DocumentHeader-help')}</Box>;
}

export default HelpButtonTooltip;
